
export default function Features() {
  const features = [
    {
      icon: 'ri-map-pin-line',
      title: '전국 420여 개 골프장',
      description: '수도권, 제주 포함 전국 명문 골프장을 자유롭게 이용할 수 있습니다.',
      items: ['전국 주요 골프장 제휴', '회원 대우 및 우선 예약', '해외 골프장 이용 가능']
    },
    {
      icon: 'ri-user-star-line',
      title: '1:1 전담 컨시어지',
      description: '스마트스코어의 독보적 IT기술력과 상담사를 통한 95% 이상의 예약 보장',
      items: ['전문 상담사 배정', '실시간 예약 지원', '맞춤형 골프장 추천']
    },
    {
      icon: 'ri-team-line',
      title: '무기명 혜택',
      description: '4인 무기명으로 본인 외 지인, 비즈니스 파트너도 제약없이 사용 가능',
      items: ['가족, 지인 공유 가능', '법인 접대 최적화', '명의 변경 자유']
    }
  ];

  return (
    <section id="features" className="py-14 md:py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-gray-900 mb-3 md:mb-4 leading-tight">
            스마트스코어 멤버십만의 특별함
          </h2>
          <p className="text-sm sm:text-base md:text-xl text-gray-600 max-w-3xl mx-auto">
            장기적이고 안정적인 서비스로 중소기업 기업부 예비 유니콘 선정
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5 md:gap-8 mb-10 md:mb-16">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-6 md:p-8 shadow-lg hover:shadow-xl transition-all border border-gray-100"
            >
              <div className="w-12 h-12 md:w-16 md:h-16 bg-blue-100 rounded-2xl flex items-center justify-center mb-4 md:mb-6">
                <i className={`${feature.icon} text-2xl md:text-3xl text-blue-600`}></i>
              </div>
              <h3 className="text-lg md:text-2xl font-bold text-gray-900 mb-2 md:mb-4">{feature.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-3 md:mb-4">{feature.description}</p>
              <ul className="space-y-2 text-sm text-gray-600">
                {feature.items.map((item, idx) => (
                  <li key={idx} className="flex items-start">
                    <i className="ri-check-line text-blue-600 mr-2 mt-0.5"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-blue-600 to-blue-800 rounded-2xl md:rounded-3xl p-6 md:p-12 text-white">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 items-center">
            <div>
              <h3 className="text-xl sm:text-2xl md:text-3xl font-bold mb-3 md:mb-4 leading-tight">
                골프 산업 전반을 직접 운영하는 압도적 전문성
              </h3>
              <p className="text-white/90 text-sm md:text-lg mb-4 md:mb-6 leading-relaxed">
                IT 솔루션과 플랫폼을 넘어, 국내외 골프장을 직접 운영하며 현장 중심의 노하우를 쌓아온 글로벌 기업입니다.
              </p>
              <div className="flex flex-wrap gap-2 md:gap-3 text-xs md:text-sm">
                <div className="flex items-center bg-white/10 px-3 md:px-4 py-1.5 md:py-2 rounded-full">
                  <i className="ri-building-line mr-1.5"></i>
                  <span>NH투자증권 PE</span>
                </div>
                <div className="flex items-center bg-white/10 px-3 md:px-4 py-1.5 md:py-2 rounded-full">
                  <i className="ri-building-line mr-1.5"></i>
                  <span>산업은행</span>
                </div>
                <div className="flex items-center bg-white/10 px-3 md:px-4 py-1.5 md:py-2 rounded-full">
                  <i className="ri-building-line mr-1.5"></i>
                  <span>VIG파트너스</span>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3 md:gap-4">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 md:p-6 border border-white/20">
                <div className="text-2xl md:text-3xl font-bold mb-1">85%</div>
                <div className="text-xs md:text-sm text-white/80">전국 골프장 관제서비스</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 md:p-6 border border-white/20">
                <div className="text-2xl md:text-3xl font-bold mb-1">400만+</div>
                <div className="text-xs md:text-sm text-white/80">누적 가입자</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 md:p-6 border border-white/20">
                <div className="text-2xl md:text-3xl font-bold mb-1">9,000억</div>
                <div className="text-xs md:text-sm text-white/80">기업 가치</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 md:p-6 border border-white/20">
                <div className="text-lg md:text-xl font-bold mb-1">해외 골프장</div>
                <div className="text-xs md:text-sm text-white/80">글로벌 진출</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
